import TagManager from 'react-gtm-module';
import config from '../src/client/config';
import { GTM_DATA_LAYER_NAME } from './utils/dataTags';

const { gtmId, env } = config;

try {
  if (env !== 'local') {
    const tagManagerArgs = {
      gtmId,
      dataLayerName: GTM_DATA_LAYER_NAME,
    };

    TagManager.initialize(tagManagerArgs);
  }
} catch (e) {
  /* eslint no-empty:0 */
}
